import { twMerge } from '@stereoagency/tailwind-config';
import React from 'react';
export default function Table(param) {
    var columns = param.columns, data = param.data, className = param.className;
    return /*#__PURE__*/ React.createElement("table", {
        className: twMerge('w-full', className)
    }, /*#__PURE__*/ React.createElement("thead", null, /*#__PURE__*/ React.createElement("tr", {
        className: "bg-green-700 rounded-t-xl"
    }, columns.map(function(column, index) {
        return /*#__PURE__*/ React.createElement("th", {
            key: column.id,
            className: twMerge('px-5 py-4.25 font-heading font-semibold text-body-xSmall text-left text-white', columns.length === index + 1 ? 'rounded-tr-xl' : '', !index ? 'rounded-tl-xl' : '', column.headerClass || '')
        }, column.headerName !== undefined ? column.headerName : column.id);
    }))), /*#__PURE__*/ React.createElement("tbody", null, data.map(function(row, index) {
        return /*#__PURE__*/ React.createElement("tr", {
            key: "data-with-legacy-".concat(JSON.stringify(row)),
            className: twMerge(data.length === index + 1 ? 'rounded-b-xl' : 'border-b border-b-neutral-500', 'bg-white')
        }, columns.map(function(column, colIndex) {
            return /*#__PURE__*/ React.createElement("td", {
                key: column.id,
                className: twMerge('px-5 py-4.5 align-baseline', data.length === index + 1 && columns.length === colIndex + 1 ? 'rounded-br-xl' : '', data.length === index + 1 && !colIndex ? 'rounded-bl-xl' : '', column.cellClass || '')
            }, column.cellRenderer ? column.cellRenderer(row[column.id] || '', index, row) : row[column.id] || '');
        }));
    })));
}

//# sourceMappingURL=Table.js.map